type SpeakerLine = {
  speaker: string;
  speech: string;
};

function extractRawContent(body: HTMLElement, content: string): string {
  const paragraphs = Array.from(body.querySelectorAll("p"));

  if (paragraphs.length === 0) {
    return (body.textContent ?? content).replace(/\r?\n/g, "\n");
  }

  return paragraphs
    .map((paragraph) => paragraph.innerHTML.replace(/<br\s*\/?>/gi, "\n"))
    .join("\n");
}

function parseSpeakerLine(line: string): SpeakerLine | null {
  const match = line.match(/^([^:\s]+):\s*(.+)$/);

  if (!match) {
    return null;
  }

  const [, speaker, speech] = match;
  return { speaker, speech };
}

function flushBlock(out: string[], block: string): string {
  if (block) {
    out.push(`<p>${block}</p>`);
  }

  return "";
}

export function collapseSpeakerLabels(content: string): string {
  const parser = new DOMParser();
  const doc = parser.parseFromString(content, "text/html");
  const body = doc.body;

  const imgEl = body.querySelector("img");
  const imgHTML = imgEl?.outerHTML ?? "";
  imgEl?.remove();

  const lines = extractRawContent(body, content)
    .split("\n")
    .map((line) => line.trim())
    .filter(Boolean);

  let lastSpeaker: string | null = null;
  let block = "";
  const out: string[] = imgHTML ? [`<p>${imgHTML}</p>`] : [];

  for (const line of lines) {
    const speakerLine = parseSpeakerLine(line);

    if (!speakerLine) {
      block = flushBlock(out, block);
      lastSpeaker = null;
      out.push(`<p>${line}</p>`);
      continue;
    }

    if (speakerLine.speaker === lastSpeaker) {
      block += ` ${speakerLine.speech}`;
      continue;
    }

    block = flushBlock(out, block);
    lastSpeaker = speakerLine.speaker;
    block = `<strong>${speakerLine.speaker}:</strong> ${speakerLine.speech}`;
  }

  flushBlock(out, block);
  return out.join("");
}
